import ExperienceItem from './ExperienceItem';
import EventItem from './EventItem';
import ItinerarioItem from './ItinerarioItem';
import DefaultItem from './DefaultItem';

const ItemTemplates = {
  //ContentTypeName: ComponentName,
  Esperienza: ExperienceItem,
  Event: EventItem,
  Itinerario: ItinerarioItem,
};

export default ItemTemplates;

export const getItemTemplate = (item) => {
  let template = item ? ItemTemplates[item['@type']] : null;
  return template ?? DefaultItem;
};
